/**
 * Generates a unique uuid ID.
 *
 * This utility creates a simple uuid ID based on a timestamp and a random number.
 * It does not guarantee absolute uniqueness but provides a reasonably unique ID for most use cases.
 *
 * @returns {string} A unique uuid ID.
 */
export function createUUId() {
    const timestamp = Date.now().toString(36); // Convert timestamp to base36 for shorter string
    const randomPart = Math.random().toString(36).substring(2, 7); // Random string (base36)

    return `uuid-${timestamp}-${randomPart}`;
}
